module.exports = __webpack_public_path__ + "static/media/towing_services_hd.d452c1d9.png";